<template>
<div
  class="ib-toggle"
  :class="{isReduce: isReduce == true && isMouseEnter == false}"
>
  <div
    class="toggle-item center-point"
    @click="customerHandle"
    :class="{
      active: agentRole == 'CUSTOMER',
      pointer: agentRole == 'IB'
    }"
  >
    {{$t('HeaderCom.userCenter')}}
  </div>
  <div
    class="toggle-item back-table"
    @click="ibHandle"
    :class="{
      active: agentRole == 'IB',
      pointer: agentRole == 'CUSTOMER'
      }"
  >
    {{$t('Agent_Backstage')}}
  </div>

</div>
</template>

<script>
import {colorRgba, IBToggleHandle} from '@/utils/index'
import { mapGetters } from 'vuex';
export default {
  name: "ibToggle",
  props: {
    isReduce: {
      type: Boolean,
      default: false
    },
    isMouseEnter: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...mapGetters(['realMobile','agentRole','listRefresh','themeColor','userInfo']),
  },
  methods: {
    customerHandle() {
      if(this.agentRole == 'CUSTOMER') return;
      IBToggleHandle(this);
    },
    ibHandle(){
      if(this.agentRole == 'IB') return;
      IBToggleHandle(this);
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/variable";

.ib-toggle {
  display: flex;
  justify-content: start;
  align-items: end;
  position: relative;
  top: -18px;
  &.isReduce {
    visibility: hidden;
  }
  overflow: hidden;
  .toggle-item {
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #D8D8D8;
    font-size: 14px;
    padding: 0 20px;
    flex: 1;
    &.center-point {
      border-top-left-radius: 20px;
      border-bottom-right-radius: 20px;
      &.active {
        height: 50px;
        line-height: 50px;
        border-top-right-radius: 20px;
        border-top-left-radius: 20px;
      }
    }
    &.back-table {
      border-top-right-radius: 20px;
      border-bottom-left-radius: 20px;
      &.active {
        height: 50px;
        line-height: 50px;
        border-top-right-radius: 20px;
        border-top-left-radius: 20px;
      }
    }
    &.active {
      //background-color: $themeColor;
      background-color: #ffffff;
      font-size: 16px;
    }
  }
}
</style>
